export const determineRoles = (model?: any): any[] => {
    if (!model) {
        return []
    }

    return [];
    // return model.rollen.reduce<RollenName[]>((acc, rolle) => {
    //     return [...acc, rolle.rollenName.rollenName]
    // }, [])
}
